<template>
    <div class="comPage">
        <ul class="pages" @click="pageClick">
            <li data-index="previous"><img src="../assets/img/zuo.png" alt="" /></li>
            <li :class="{ active: currentPage == 1 }" data-index="1"><code>1</code></li>
            <li v-show="leftMore">...</li>
            <li v-for="item in pageList" :key="item" :class="{ active: currentPage == item }" :data-index="item">
                <code>{{ item }}</code>
            </li>
            <li v-show="rightMore">...</li>
            <li v-show="finalPage != 1" :class="{ active: currentPage == finalPage }" :data-index="finalPage">
                <code>{{ finalPage }}</code>
            </li>
            <li data-index="next"><img src="../assets/img/you.png" alt="" /></li>
            <li class="pageInput" data-index="input">
                <input type="text" v-model="pageJump" @keyup.enter="jump" />
            </li>
            <li class="pageBtn" data-index="button">
                <button @click="jump"><code>跳转</code></button>
            </li>
        </ul>
    </div>
</template>

<script>
/*
    4月27日修改
*/
export default {
    props: {
        totalPage: [Number, String],
        total: {
            type: [Number, String],
            default: 10,
        },
        pageSize: {
            type: [Number, String],
            default: 10,
        },
        currentPage: {
            type: [Number, String],
            default: 1,
        },
    },
    data() {
        return {
            leftMore: false,
            rightMore: false,
            pageJump: "",
        };
    },
    watch: {
        pageJump(val) {
            if (isNaN(val)) {
                this.pageJump = val.replace(/\D+/g, "");
            }
        },
    },
    methods: {
        pageClick(e) {
            let index, pageTo;
            if (e.target.localName === "li") {
                index = e.target.dataset.index;
            } else if (e.target.localName === "ul") {
                return;
            } else {
                let node = e.target.parentNode;
                while (node.localName != "li") {
                    node = node.parentNode;
                }
                index = node.dataset.index;
            }
            if (index == "previous" && this.currentPage > 1) {
                pageTo = this.currentPage - 1;
            } else if (index == "next" && this.currentPage < this.finalPage) {
                pageTo = parseInt(this.currentPage) + 1;
            } else if (!isNaN(parseInt(index))) {
                pageTo = parseInt(index);
            } else if (index == "previous" && this.currentPage <= 1) {
                layer.msg("当前页为第一页", {
                    time: 1000,
                });
                return;
            } else if (index == "next" && this.currentPage >= this.finalPage) {
                layer.msg("当前页为最后一页", {
                    time: 1000,
                });
                return;
            } else if (index == "button" || index == "input") {
                return;
            }
            if (pageTo == this.currentPage || !pageTo) {
                return;
            }
            this.$emit("currentChange", pageTo);
        },
        jump() {
            if (this.pageJump > 0 && this.pageJump <= this.finalPage) {
                this.$emit("currentChange", parseInt(this.pageJump));
            } else if (this.pageJump > this.finalPage) {
                layer.msg("超出最大页数");
            } else {
                layer.msg("请输入正确页数");
            }
        },
    },
    computed: {
        finalPage() {
            return this.totalPage || Math.ceil(this.total / this.pageSize);
        },
        pageList() {
            let finalPage = this.finalPage;
            let arr = [];
            this.leftMore = false;
            this.rightMore = false;
            if (finalPage < 10) {
                for (let i = 2; i < finalPage; i++) {
                    arr.push(i);
                }
            } else {
                if (this.currentPage < 6) {
                    this.rightMore = true;
                    for (let i = 2; i < 8; i++) {
                        arr.push(i);
                    }
                } else if (this.currentPage >= 6 && this.currentPage < finalPage - 4) {
                    this.leftMore = true;
                    this.rightMore = true;
                    for (let i = this.currentPage - 2; i < parseInt(this.currentPage) + 3; i++) {
                        arr.push(i);
                    }
                } else if (this.currentPage > finalPage - 5) {
                    this.leftMore = true;
                    for (let i = finalPage - 6; i < finalPage; i++) {
                        arr.push(i);
                    }
                }
            }
            return arr;
        },
    },
};
</script>

<style lang="scss" scoped>
.comPage {
    padding: 20px 0;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.pages {
    display: flex;
    justify-content: center;
    align-items: center;
    li {
        min-width: 40px;
        padding: 0 5px;
        height: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        user-select: none;
        margin: 0 6px;
        border: 1px solid #bbb;
        cursor: pointer;
        &:hover {
            color: #ff8914;
            border-color: #ff8914;
            img {
                filter: invert(71%) sepia(33%) saturate(5915%) hue-rotate(348deg) brightness(99%) contrast(103%);
            }
        }
        &.active {
            background: #ff8914;
            border-color: #ff8914;
            color: #fff;
        }
        img {
            width: 16px;
            height: 16px;
        }
    }
    .pageInput {
        width: 60px;
        margin-left: 20px;
        border: none;
        input {
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            font-size: 16px;
            text-align: center;
            outline-color: #ff8914;
            &:focus {
                border: none;
            }
        }
    }
    .pageBtn {
        width: 50px;
        padding: 0;
        button {
            box-sizing: border-box;
            width: 100%;
            height: 100%;
            border: none;
            background: #fff;
            font-size: 14px;
            outline: none;
            &:hover {
                color: #ff8914;
                cursor: pointer;
            }
            &:active {
                transform: scale(0.95);
            }
        }
    }
}
</style>
